import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { membersFilterConfig } from '../../../configs/member-filter-config';
import { MemberFilterSelectedValues } from '../../../configs/member-filter-config/filter-selected-values';

export const LeadAssigneeFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Assignee'
      config={membersFilterConfig({ facetName: 'assignee' })}
      renderValues={MemberFilterSelectedValues}
    />
  );
};
